export default __webpack_public_path__ + "static/media/source_instagram.ed068efa.svg";